// extracted by mini-css-extract-plugin
module.exports = {"Game":"Game_Game__3C5yo","fadein":"Game_fadein__3KgUi","Game__iframe":"Game_Game__iframe__2NHmX"};